<h2 mat-dialog-title id="app-recovery-title" i18n="@@appRecoveryTitle">
  Seite konnte nicht geladen werden
</h2>
<mat-dialog-content>
  <p id="app-recovery-description" i18n="@@appRecoveryDescription">
    Bitte lade die aktuelle Version, um diese Seite erneut zu öffnen.
  </p>
  @if (reloadFailed()) {
    <p role="alert" i18n="@@appRecoveryFailed">
      Neuladen fehlgeschlagen. Prüfe deine Internetverbindung und versuche es
      erneut.
    </p>
  }
  <p role="status">
    @if (isReloading()) {
      <span i18n="@@appRecoveryReloading">Aktuelle Version wird geladen…</span>
    }
  </p>
</mat-dialog-content>
<mat-dialog-actions>
  <button
    mat-flat-button
    color="primary"
    type="button"
    [disabled]="isReloading()"
    (click)="reload()"
  >
    <span i18n="@@appRecoveryReload">Aktuelle Version laden</span>
  </button>
</mat-dialog-actions>
